export default {
    lessons: [],
    lesson: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/lesson/state.js